import Slides from '../slides/Slides'
import iconContactoMasculino from "../../img/iconContactoMasculino.jpg";

const ServicioDeAtencion = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides="serviciodetencion"/>
         <div className="section grey lighten-4 py-5 animated fadeIn">
            <div className="container">
               
               {/* TÍTULO PRINCIPAL */}
               <div className="row center mb-4">
                  <h4 className="light-blue-text text-accent-3 institutional-title">SERVICIO DE ATENCIÓN AL ASEGURADO</h4>
               </div>

               {/* TARJETA DESCRIPTIVA SUPERIOR */}
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#ffffff', padding: '35px' }}>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           La compañía de seguros <strong>LATITUD SUR S.A.</strong> dispone de un Servicio de Atención al Asegurado que atenderá las consultas y reclamos que presenten los tomadores de seguros, asegurados, beneficiarios y/o derechohabientes.
                        </p>
                     </div>
                  </div>
               </div>

               {/* SUBTÍTULO DE CONTACTOS */}
               <div className="row center mb-4">
                  <h5 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600', fontSize: '1.8rem' }}>
                     El servicio mencionado está integrado por:
                  </h5>
               </div>

               {/* TARJETAS DE CONTACTOS (RESPONSABLE Y SUPLENTE) */}
               <div className="row justify-content-center mb-5">
                  <div className="col s12 m12 l6">
                     <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderTop: '4px solid #039be5', padding: '20px' }}>
                        <div className="row valign-wrapper mb-0">
                           <div className="col s3 m2">
                              <img src={iconContactoMasculino} alt="Responsable" className="circle responsive-img" />
                           </div>
                           <div className="col s9 m10">
                              <span className="grey-text text-darken-3" style={{ lineHeight: '1.6', display: 'block' }}>
                                 <strong className="light-blue-text text-darken-2" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Responsable</strong><br/>
                                 <strong style={{ fontSize: '1.1rem' }}>Ramiro Javier Montero</strong><br/>
                                 <span style={{ fontSize: '0.95rem' }}>0388 - 4911741 Int.: 302</span><br/>
                                 <a href="mailto:rmontero@latitudsursa.com.ar" className="light-blue-text text-darken-2" style={{ fontSize: '0.95rem' }}>rmontero@latitudsursa.com.ar</a>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>

                  <div className="col s12 m12 l6">
                     <div className="card-panel white z-depth-1 hoverable" style={{ borderRadius: '8px', borderTop: '4px solid #039be5', padding: '20px' }}>
                        <div className="row valign-wrapper mb-0">
                           <div className="col s3 m2">
                              <img src={iconContactoMasculino} alt="Suplente" className="circle responsive-img" />
                           </div>
                           <div className="col s9 m10">
                              <span className="grey-text text-darken-3" style={{ lineHeight: '1.6', display: 'block' }}>
                                 <strong className="light-blue-text text-darken-2" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Suplente</strong><br/>
                                 <strong style={{ fontSize: '1.1rem' }}>José Prudencio Gutiérrez</strong><br/>
                                 <span style={{ fontSize: '0.95rem' }}>0388 - 4911741 Int.: 127</span><br/>
                                 <a href="mailto:jgutierrez@latitudsursa.com.ar" className="light-blue-text text-darken-2" style={{ fontSize: '0.95rem' }}>jgutierrez@latitudsursa.com.ar</a>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               {/* TARJETA INFORMATIVA INFERIOR (SSN) */}
               <div className="row justify-content-center">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#ffffff', padding: '35px' }}>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           En caso de que existiera un reclamo ante la entidad aseguradora y que el mismo no haya sido resuelto o haya sido desestimado, total o parcialmente, o que haya sido denegada su admisión, podrá comunicarse con la <strong>Superintendencia de Seguros de la Nación</strong> a través del sitio web oficial{' '}
                           <a href="https://www.argentina.gob.ar/ssn" target="_blank" rel="noopener noreferrer" className="light-blue-text text-darken-2" style={{ fontWeight: '600', textDecoration: 'underline' }}>
                              argentina.gob.ar/ssn
                           </a>
                        </p>
                     </div>
                  </div>
               </div>

            </div>      
         </div>
      </>
   )
}

export default ServicioDeAtencion